(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var parallaxSections = [];
  var faceBridge = null;
  var faceBridgeImage = null;
  var splitSection = null;
  var splitImage = null;
  var ticking = false;

  function collect() {
    parallaxSections = Array.prototype.slice.call(
      document.querySelectorAll('[data-skn-parallax-section]')
    );
    faceBridge = document.querySelector('[data-skn-face-bridge]');
    faceBridgeImage = faceBridge
      ? faceBridge.querySelector('[data-skn-fb-image]')
      : null;
    splitSection = document.querySelector('[id*="section_JYk9Q4"]');
    splitImage = splitSection
      ? splitSection.querySelector('.layout-panel-flex--row > .image-block img')
      : null;
  }

  function updateParallaxSections() {
    var viewportHeight = window.innerHeight;

    parallaxSections.forEach(function (section) {
      var bg = section.querySelector('[data-skn-parallax-bg]');
      if (!bg) return;

      var rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      var speed = parseFloat(section.getAttribute('data-skn-parallax-speed')) || 0.3;
      var travel = rect.height * 0.35 * speed;
      var progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      var offset = (progress - 0.5) * travel * 2;

      bg.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(1.08)';
    });
  }

  function updateFaceBridge() {
    if (!faceBridge || !faceBridgeImage) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var viewportHeight = window.innerHeight;
    var rect = faceBridge.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportHeight) return;

    var into = Math.max(0, -rect.top);
    var length = Math.max(viewportHeight, faceBridge.offsetHeight - viewportHeight);
    var progress = length > 0 ? Math.min(1, into / length) : 0;
    var offset = (progress - 0.5) * viewportHeight * 0.5;

    faceBridgeImage.style.transform =
      'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(1.1)';
  }

  function updateSplitParallax() {
    if (!splitSection || !splitImage) return;

    var rect = splitSection.getBoundingClientRect();
    var viewportHeight = window.innerHeight;

    if (rect.bottom < 0 || rect.top > viewportHeight) return;

    var speed = 0.35;
    var progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
    var offset = (progress - 0.5) * rect.height * speed;

    splitImage.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(1.06)';
  }

  function update() {
    updateParallaxSections();
    updateFaceBridge();
    updateSplitParallax();
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function init() {
    collect();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      collect();
      update();
    });
    document.addEventListener('shopify:section:load', function () {
      collect();
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
